<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 8.55553H20"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.2222 17.4444H6.66667C5.19391 17.4444 4 16.2505 4 14.7778V7.66667C4 6.19391 5.19391 5 6.66667 5H17.3333C18.8061 5 20 6.19391 20 7.66667V14.7778"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5555 14C15.4169 14 15.2915 14.0564 15.2009 14.1475L12.5353 16.8131C12.34 17.0084 12.34 17.325 12.5353 17.5202C12.7305 17.7155 13.0471 17.7155 13.2424 17.5202L15.0555 15.7071V20.7222C15.0555 20.9984 15.2794 21.2222 15.5555 21.2222C15.8316 21.2222 16.0555 20.9984 16.0555 20.7222V15.7071L17.8686 17.5202C18.0639 17.7155 18.3805 17.7155 18.5757 17.5202C18.771 17.325 18.771 17.0084 18.5757 16.8131L15.9091 14.1464C15.8153 14.0527 15.6881 14 15.5555 14C15.5555 14 15.5555 14 15.5555 14Z"
      :fill="clr"
    />
  </svg>
</template>

<script>
export default {
  props: {
    clr: {
      default: "#768391"
    }
  }
};
</script>
